import bbox from "@turf/bbox";

/**
 * Calculates bounds from an array of GeoJSON features using Turf.js
 * Returns [[minLng, minLat], [maxLng, maxLat]] | null
 */
export function calculateBoundsFromFeatures(
  features: GeoJSON.Feature[] | GeoJSON.FeatureCollection,
): [[number, number], [number, number]] | null {
  const featuresArray = Array.isArray(features) 
    ? features 
    : features.features;

  if (!featuresArray || featuresArray.length === 0) {
    return null;
  }

  // Create FeatureCollection for turf
  const featureCollection: GeoJSON.FeatureCollection = {
    type: "FeatureCollection",
    features: featuresArray,
  };

  try {
    // turf bbox returns [minX, minY, maxX, maxY] (west, south, east, north)
    const bboxResult = bbox(featureCollection);
    
    if (bboxResult?.length !== 4) {
      return null;
    }

    const [minLng, minLat, maxLng, maxLat] = bboxResult;

    if (
      !Number.isFinite(minLng) ||
      !Number.isFinite(minLat) ||
      !Number.isFinite(maxLng) ||
      !Number.isFinite(maxLat)
    ) {
      console.warn("Invalid bounds calculated:", { minLng, minLat, maxLng, maxLat });
      return null;
    }

    if (minLng >= maxLng || minLat >= maxLat) {
      console.warn("Invalid bounds: min >= max", { minLng, minLat, maxLng, maxLat });
      return null;
    }

    return [[minLng, minLat], [maxLng, maxLat]];
  } catch (error) {
    console.warn("Failed to calculate bounds from features:", error);
    return null;
  }
}

